import axios from '../script/axiosDJ'

export default {
  getSession (resultCallback) {
    axios.requestWith({
      url: '/api/session',
      method: 'get',
      resultCallback: resultCallback
    })
  },
  amsAlert (type, value) {
    if (type === 'retry') {
      alert(value + '\n잠시 후 다시 시도해주세요.')
    } else if (type === 'contact') {
      alert(value + '\n잠시 후 다시 시도해주세요.\n지속적으로 문제가 발생할 경우 관리자에게 문의해주세요.')
    } else {
      alert(value)
    }
  },
  checkChangedData (data, origin) {
    let result = {}
    Object.keys(data).forEach(key1 => {
      result[key1] = data[key1]
      Object.keys(origin).forEach(key2 => {
        if (key1 === key2 && data[key1] === origin[key2]) {
          delete result[key1]
        }
      })
    })
    return result
  },
  getOnlyNumber (value) {
    return value != null ? value.toString().replace(/[^0-9]/g, '') : ''
  },
  getDatepickerLocal () {
    return {
      dow: 0,
      hourTip: '시간 선택',
      minuteTip: '분 선택',
      secondTip: '초 선택',
      yearSuffix: '년',
      monthsHead: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
      months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
      weeks: '일_월_화_수_목_금_토'.split('_'),
      cancelTip: '취소',
      submitTip: '선택'
    }
  },
  getFormattedDate (date) {
    if (date == null) return ''
    let _date = new Date(date)
    return _date.getFullYear() + '-' + ((_date.getMonth() + 1) < 10 ? '0' + (_date.getMonth() + 1) : (_date.getMonth() + 1)) + '-' + (_date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate())
  },
  checkValidateData (type, value) {
    if (value != null) {
      if (type === 'session') {
        return (value !== 'null' && value.length > 0) || (value !== '[]' && value.length > 0)
      } else if (type === 'string') {
        return value !== '' && value.length > 0
      } else if (type === 'number') {
        return typeof value === 'number'
      } else if (type === 'date') {
        return typeof value === 'object'
      } else if (type === 'email') {
        let regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
        return regex.test(value)
      } else {
        return false
      }
    } else {
      return false
    }
  },
  checkValidateLength (type, value, length) {
    if (type === 'min') {
      if (typeof value === 'string') {
        return value.length >= length
      } else if (typeof value === 'number') {
        return value >= length
      } else {
        return false
      }
    } else if (type === 'max') {
      if (typeof value === 'string') {
        return value.length <= length
      } else if (typeof value === 'number') {
        return value <= length
      } else {
        return false
      }
    } else if (type === 'minmax' && typeof length === 'object' && length.length === 2) {
      if (typeof value === 'string') {
        return value.length >= length[0] && value.length <= length[1]
      } else if (typeof value === 'number') {
        return value >= length[0] && value <= length[1]
      } else {
        return false
      }
    } else if (type === 'equal') {
      if (typeof value === 'string') {
        return value.length === length
      } else if (typeof value === 'number') {
        return value === length
      } else {
        return false
      }
    } else {
      return false
    }
  },
  fileDownload (url) {
    let browserName
    let userAgent = navigator.userAgent
    switch (true) {
      case /Trident|MSIE/.test(userAgent):
        browserName = 'ie'
        break
      case /Edge/.test(userAgent):
        browserName = 'edge'
        break
      case /Chrome/.test(userAgent):
        browserName = 'chrome'
        break
      case /Safari/.test(userAgent):
        browserName = 'safari'
        break
      case /Firefox/.test(userAgent):
        browserName = 'firefox'
        break
      case /Opera/.test(userAgent):
        browserName = 'opera'
        break
      default:
        browserName = 'unknown'
    } // ie 브라우저 및 EDGE 브라우저
    if (browserName === 'ie' || browserName === 'edge') { // ie11
      let _window = window.open(url, '_blank')
      _window.document.close()
      _window.document.execCommand('SaveAs', true, 'file.hwp' || url)
      _window.close()
    } else { // chrome
      let filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
      let xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function () {
        let a = document.createElement('a')
        a.href = window.URL.createObjectURL(xhr.response) // xhr.response is a blob
        a.download = filename // Set the file name.
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
      }
      // xhr.onreadystatechange = () => {
      //   if (xhr.readyState === 4) {
      //     if ((xhr.status === 200) || (xhr.status === 0)) {
      //       let a = document.createElement('a')
      //       a.href = window.URL.createObjectURL(xhr.response) // xhr.response is a blob
      //       let attr = document.createAttribute('download')
      //       a.setAttributeNode(attr)
      //       a.download = filename
      //       a.style.display = 'none'
      //       document.body.appendChild(a)
      //       a.click()
      //       a.remove()
      //     } else {
      //       alert('Sorry. Cannot find file.')
      //     }
      //   }
      // }
      xhr.open('GET', url)
      xhr.setRequestHeader('authorization', sessionStorage.accessToken)
      xhr.send()
    }
  },
  getOriginalFileName (value) {
    if (!this.checkValidateData('string', value)) {
      this.amsAlert('retry', '파일명이 읽을 수 없습니다.')
      return null
    }
    let fileNameArray = []
    for (let i = 0; i < value.split('_').length - 1; i++) {
      fileNameArray.push(value.split('_')[i])
    }
    return fileNameArray.join('_') + '.' + value.split('.')[value.split('.').length - 1]
  },
  getHourMinuteList () {
    let hList = []
    for (let i = 0; i < 23; i++) {
      const hour = (i + 1) < 10 ? '0' + (i + 1) : (i + 1)
      hList.push({codeValue: `${hour}:00:00`, codeName: `${hour}시`})
      hList.push({codeValue: `${hour}:10:00`, codeName: `${hour}시 10분`})
      hList.push({codeValue: `${hour}:20:00`, codeName: `${hour}시 20분`})
      hList.push({codeValue: `${hour}:30:00`, codeName: `${hour}시 30분`})
      hList.push({codeValue: `${hour}:40:00`, codeName: `${hour}시 40분`})
      hList.push({codeValue: `${hour}:50:00`, codeName: `${hour}시 50분`})
    }
    return hList
  },
  getNumberWithCommas (value) {
    const values = value.toString().split('.')
    values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return values.join('.')
  },
  detectMobile () {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i]
    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/common.js